module.exports = __webpack_public_path__ + "img/Лого Вокзалы России 1.21beb832.svg";